<template>
  <custom-dialog width="60%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0">
      <div class="search-hd">
        <search-input
          style="float: right"
          :placeholder="$t('base_role_user_add_dialog.ygxmdlzhlxdhyx')"
          v-model="formSearch.search"
          @fetch="onPageChange({page: 1})"
        ></search-input>
      </div>
      <custom-table
        type="checkbox"
        tableCode="roleAssociateUser"
        v-model="tableSelect"
        :data="roleUserList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{$t('Common.com_cancel')}}</el-button>
      <el-button type="primary" @click="saveRoleUser">{{$t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableSelect: [],
      roleUserList: [],
      totalRows: 0,

      formSearch: {
        roleId: '',
        search: '',
        pageSize: 20,
        pageNum: 1,
        isAssociated: 0
      }
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.roleId = this.model.data.roleId;
      this.formSearch.orgId = this.model.data.orgId;
      this.getRoleUserPage();

    },
    // 获取用户列表
    getRoleUserPage: function () {
      this.$getJSON(apis.RoleUserPage, this.formSearch).then((res) => {
        this.roleUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRoleUserPage();
    },
    // 保存编辑用户
    saveRoleUser: function () {
      const userIds = this.tableSelect.map(t => ({
        bizId: t.userId,
        bizName: t.userName,
        bizType: 1
      }));
      this.$postJSON(apis.RoleUserBind, {
        roleId: this.model.data.roleId,
        bizInfos: userIds
      }, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss"></style>
